<template>
	<input v-if="showPlaceholder" type="text" v-bind="$attrs" @focus="activateDatePicker" />

	<input
		v-else
		ref="dateInput"
		type="date"
		v-bind="$attrs"
		v-model.lazy="formattedDate"
		:max="max"
		@blur="handleBlur"
		class="date-input"
	/>
</template>

<script>

export default {
	name: 'DateInput',

	model: {
		prop: 'value',
		event: 'change'
	},

	data () {
		return {
			showPlaceholder: true
		}
	},

	inheritAttrs: false,

	props: {
		value: {
			required: true
		},

		allowFutureDates: Boolean
	},

	computed: {
		formattedDate: {
			get () {
				if (this.value && this.value.length === 10) {
					const [day, month, year] = (this.value || '').split('.')
					return new Date(`${year}-${month}-${day}`).toISOString().slice(0, 10)
				}
				return this.value
			},
			set (value) {
				console.log('formatted date setter', value)
				let date = value
				if (date && date.length === 10) {
					const [yyyy, mm, dd] = date.split('-')
					date = `${dd}.${mm}.${yyyy}`
				}
				this.$emit('change', date)
			}
		},

		max () {
			if (!this.allowFutureDates) {
				return (new Date()).toISOString().slice(0, 10)
			}
			return undefined
		}
	},

	methods: {
		activateDatePicker () {
			this.showPlaceholder = false

			this.$nextTick(() => {
				this.$refs.dateInput.focus(); 	// for iOS
				this.$refs.dateInput.click();	// for Android
			})
		},

		handleBlur (e) {
			if (!e.target.value) {
				this.showPlaceholder = true
			}
		}
	},

	created() {
		this.showPlaceholder = !this.formattedDate;
	}
}
</script>

<style scoped lang="scss">
.date-input {
	appearance: auto !important;
}

::-webkit-datetime-edit {
	// for chrome date inputs bigger size
	line-height: 2em;	// 2em for the shop. Other usages are less prioritized. Inheriting value is impossible via css
	padding: 0;
	margin-bottom: -2px;
}

input::-webkit-date-and-time-value {
	height: 2em;	// 2em for the shop. Other usages are less prioritized. Inheriting value is impossible via css
	line-height:2em;
}
</style>
